import React from 'react';
const productLinks = [{
  label: 'Product',
  href: '#product'
}, {
  label: 'How It Works',
  href: '#workflow'
}, {
  label: 'AI Security',
  href: '#ai-security'
}, {
  label: 'Evidence',
  href: '#evidence'
}, {
  label: 'Pricing',
  href: '#pricing'
}];
const companyLinks = [{
  label: 'About',
  href: '#about'
}, {
  label: 'Jobs',
  href: '#jobs'
}, {
  label: 'Early Access',
  href: '#early-access'
}, {
  label: 'Contact',
  href: 'mailto:contact@periscan.com'
}];
export function Footer() {
  return <footer className="relative w-full border-t border-white/5 bg-[#050608]" data-id="element-456">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20" data-id="element-457">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20" data-id="element-458">
          {/* Brand */}
          <div className="md:col-span-5" data-id="element-459">
            <div className="flex items-center gap-2.5 mb-6" data-id="element-460">
              <div className="relative w-8 h-8 flex items-center justify-center" data-id="element-461">
                <div className="absolute inset-0 rounded-md border border-[#1a8fd4]/40" data-id="element-462" />
                <div className="absolute inset-1 rounded-sm bg-[#1a8fd4]/10" data-id="element-463" />
                <div className="relative w-2 h-2 rounded-full bg-[#1a8fd4] shadow-[0_0_8px_#1a8fd4]" data-id="element-464" />
              </div>
              <span className="font-semibold text-white tracking-tight text-lg" data-id="element-465">
                Periscan
              </span>
            </div>
            <p className="text-base text-white/60 mb-3 max-w-sm leading-relaxed" data-id="element-466">
              Continuous security validation, priced like SaaS.
            </p>
            <p className="font-mono text-sm text-[#1a8fd4]" data-id="element-467">
              Find the path. Fix the risk. Prove it's gone.
            </p>
          </div>

          {/* Links */}
          <div className="md:col-span-3 md:col-start-7" data-id="element-468">
            <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-6" data-id="element-469">
              Product
            </p>
            <ul className="space-y-3" data-id="element-470">
              {productLinks.map(l => <li key={l.label} data-id="element-471">
                  <a href={l.href} className="text-sm text-white/70 hover:text-white transition-colors" data-id="element-472">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div className="md:col-span-3" data-id="element-473">
            <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-6" data-id="element-474">
              Company
            </p>
            <ul className="space-y-3" data-id="element-475">
              {companyLinks.map(l => <li key={l.label} data-id="element-476">
                  <a href={l.href} className="text-sm text-white/70 hover:text-white transition-colors" data-id="element-477">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-478">
          <p className="font-mono text-xs text-white/40 uppercase tracking-widest" data-id="element-479">
            © 2026 Periscan. All rights reserved.
          </p>
          <p className="font-mono text-xs text-white/30 uppercase tracking-widest" data-id="element-480">
            Reborn for the AI era
          </p>
        </div>
      </div>
    </footer>;
}